module.exports = __webpack_public_path__ + "img/btn-edit-en.1a93adba.png";